module.exports = __webpack_public_path__ + "img/waiting_ico.ba456adb.png";